import { MeetingTemplatePicker } from "components/Forms/MeetingTemplatePicker";
import { LyneFormField } from "components/Lyne/LyneFormField";
import { ResourceKeys } from "providers";

interface StandardMeetingsPanelFormProps {
  templateId?: number;
  setTemplateId: (id: number) => void;
}

export const StandardMeetingsPanelForm = ({ templateId, setTemplateId }: StandardMeetingsPanelFormProps) => {
  const size = "m";
  const name = "StandardMeetingsPanel_TemplateId";

  return (
    <div>
      <LyneFormField
        size={size}
        name={name}
        label={ResourceKeys.Meeting_TemplateId_Title}
        contextHelp={ResourceKeys.ContextHelp_TemplateId_Description}
      >
        <MeetingTemplatePicker
          name={name}
          className="add-meeting-template-id"
          onChange={setTemplateId}
          value={templateId}
          isDisabled={(x) => x.disabled === true || x.id < 0}
        />
      </LyneFormField>
    </div>
  );
};
